import * as Sentry from "@sentry/nextjs";
import React from "react";
import useSWR from "swr";
//next/headers cookie


let debug = process.env.APP_DEBUG || false;
let api_url = process.env.API_URL
let skipcacheratio = process.env.SKIP_CACHE_RATE || 0.4
let cookie_suffix = '';
if (typeof window !== 'undefined') {
    if (window.location.hostname == "localhost" || window.location.hostname == '127.0.0.1') {
        api_url = `http://${window.location.hostname}:8000/api`;
        // cookie_suffix = ' SameSite=None';
        cookie_suffix = ' SameSite=None Secure';
        // debug = true;
    } else if (window.location.hostname == "ept-pilot.nphl.go.ke" || window.location.hostname.includes("-pilot")) {
        api_url = "https://ept-pilot.nphl.go.ke/api";
        cookie_suffix = ' SameSite=None Secure';
        debug = false;
    } else {
        api_url = "https://ept.nphl.go.ke/api";
        cookie_suffix = ' SameSite=None Secure';
        debug = false;
    }
}
export const API_URL = api_url;

export const doLogin = async (email, password, rtr) => {
    if (typeof window !== 'undefined') {
        // clear session storage
        // window.sessionStorage.removeItem('user');
        // window.sessionStorage.removeItem('isLoggedIn');
        document.cookie = `isLoggedIn=false; path=/;${cookie_suffix}`
        document.cookie = `user=; path=/;${cookie_suffix}`
        document.cookie = `session=; path=/;${cookie_suffix}`
        document.cookie = `activeScopeCode=; path=/;${cookie_suffix}`
        document.cookie = `token=; path=/;${cookie_suffix}`

        return fetch(api_url + '/auth/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email, password })
        }).then(res => res.json()).then(data => {
            if (debug) console.log('/auth/login data::', data)
            if (data.status === false) {
                if (debug) console.log('/auth/login 401 error::', data)
                return data
            } else {
                // window.sessionStorage.setItem('isLoggedIn', true)
                // window.sessionStorage.setItem('token', data.token)
                // store isLoggedin in cookie
                document.cookie = `isLoggedIn=true; path=/;${cookie_suffix}`
                // store token in cookie
                document.cookie = `token=${data.token}; path=/;${cookie_suffix}`
                // get user details
                return fetch(api_url + '/auth/user', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${data.token}`
                    }
                }).then(res => res.json()).then(data => {
                    if (debug) console.log('/auth/user data (doLogin) ::', data)
                    if (data.status === true) {
                        // window.sessionStorage.setItem('user', JSON.stringify({ ...data.user, type: (data.user.role == 1 ? "admin" : "participant") }))
                        // window.sessionStorage.setItem('user', JSON.stringify({ ...data.user, type: data.role?.name }))
                        // store user in cookie
                        document.cookie = `session=${JSON.stringify(data)}; path=/;${cookie_suffix}`
                        document.cookie = `user=${JSON.stringify({ ...data.user, type: data.role?.name })}; path=/;${cookie_suffix}`
                        // redirect to admin or user dashboard
                        if (data.role?.name.toLowerCase() == "superadmin" || data.role?.name.toLowerCase() == "super_admin" || data.role?.name.toLowerCase() == "admin" || data.role?.name.toLowerCase().trim().split(' ').join('_') == "scope_manager") {
                            rtr.push('/admin', undefined, { unstable_skipClientCache: true })
                        } else if (
                            data.role?.name.toLowerCase().includes("coordinator")
                            || data.role?.name.toLowerCase() == "coordinator"
                            || data.role?.name.toLowerCase() == "co-ordinator"
                            || data.role?.name.toLowerCase() == "county coordinator"
                            || data.role?.name.toLowerCase() == "subcounty coordinator"
                        ) {
                            rtr.push('/region', undefined, { unstable_skipClientCache: true })
                        } else if (data.role?.name.toLowerCase() == "partner") {
                            rtr.push('/partner', undefined, { unstable_skipClientCache: true })
                        } else {
                            rtr.push('/user', undefined, { unstable_skipClientCache: true })
                        }
                        // sentry capture
                        // Sentry.captureMessage(`User logged in successfully ${data?.role?.name}`);
                        setTimeout(() => {
                            window.location.reload()
                        }, 500);
                    } else {
                        // show error
                        if (debug) console.error('/auth/user error (doLogin) ::', data)
                        // window.sessionStorage.setItem('isLoggedIn', false)
                        // window.sessionStorage.removeItem('token')
                        // window.sessionStorage.removeItem('user')
                        // remove isLoggedIn cookie
                        document.cookie = `isLoggedIn=false; path=/;${cookie_suffix}`
                        // remove user cookie
                        document.cookie = `user=; path=/;${cookie_suffix}`
                        document.cookie = `session=; path=/;${cookie_suffix}`
                        document.cookie = `activeScopeCode=; path=/;${cookie_suffix}`
                        // remove token cookie
                        document.cookie = `token=; path=/;${cookie_suffix}`
                        rtr.push('/login', undefined, { unstable_skipClientCache: true })
                    }
                    return data
                }).catch(error => {
                    if (debug) console.error('/auth/user error::', error)
                    return error
                })
            }
        }).catch(err => {
            if (debug) console.error('/auth/login error::', err)
            return err
        })
    } else {
        console.error('window is undefined')
    }
}
export const sendPasswordResetLink = async (email, rtr) => {
    if (typeof window !== 'undefined') {
        return fetch(api_url + '/auth/forgot-password-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email })
        }).then(res => res.json()).then(data => {
            if (debug) console.log('/auth/forgot-password-email data::', data)
            if (data.status === false) {
                if (debug) console.log('/auth/forgot-password-email error::', data)
            }
            return data
        }).catch(err => {
            if (debug) console.error('/auth/forgot-password-email exception::', err)
            return err
        })
    }
}
export const sendPasswordResetSMSCode = async (phone, code, password, password_confirmation, rtr) => {
    if (typeof window !== 'undefined') {
        return fetch(api_url + '/auth/forgot-password-sms', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ phone, code, password, password_confirmation })
        }).then(res => res.json()).then(data => {
            if (debug) console.log('/auth/forgot-password-sms data::', data)
            if (data.status === false) {
                if (debug) console.log('/auth/forgot-password-sms error::', data)
            }
            return data
        }).catch(err => {
            if (debug) console.error('/auth/forgot-password-sms exception::', err)
            return err
        })
    }
}

export const doPasswordReset = async (email, password, password_confirmation, token, rtr) => {
    if (typeof window !== 'undefined') {
        return fetch(api_url + '/auth/reset-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email, password, password_confirmation, token })
        }).then(res => res.json()).then(data => {
            if (debug) console.log('/auth/reset-password data::', data)
            if (data.status === false) {
                if (debug) console.log('/auth/reset-password error::', data)
                return data
            } else {
                // rtr.push('/login', undefined, { unstable_skipClientCache: true })
                return data
            }
        }).catch(err => {
            if (debug) console.error('/auth/reset-password error::', err)
            return err
        })
    }
}
export const doSignup = async (name, email, national_id, phone, password, rtr) => {
    if (typeof window !== 'undefined') {
        // clear session storage
        // window.sessionStorage.removeItem('user');
        // window.sessionStorage.removeItem('isLoggedIn');
        document.cookie = `isLoggedIn=false; path=/;${cookie_suffix}`
        document.cookie = `user=; path=/;${cookie_suffix}`
        document.cookie = `session=; path=/;${cookie_suffix}`
        document.cookie = `activeScopeCode=; path=/;${cookie_suffix}`
        document.cookie = `token=; path=/;${cookie_suffix}`

        return fetch(api_url + '/auth/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name, email, national_id, phone, password })
        }).then(res => res.json()).then(data => {
            if (data.status === false) {
                if (debug) console.log('/auth/register error::', data)
                return data
            } else {
                if (debug) console.log('/auth/register success::', data)
                // // sentry capture
                // Sentry.captureMessage(`User registered successfully ${email}`);
                return data
            }
        }).catch(err => {
            if (debug) console.error('/auth/register error::', err)
            return err
        })
    }
}

export const doLogout = async (rtr) => {
    if (typeof window !== 'undefined') {
        // clear session storage
        // window.sessionStorage.removeItem('user');
        // window.sessionStorage.removeItem('isLoggedIn');
        // window.sessionStorage.removeItem('token');
        const tkn = getCookie('token')
        document.cookie = `isLoggedIn=false; path=/;${cookie_suffix}`
        document.cookie = `user=; path=/;${cookie_suffix}`
        document.cookie = `session=; path=/;${cookie_suffix}`
        document.cookie = `activeScopeCode=; path=/;${cookie_suffix}`
        document.cookie = `token=; path=/;${cookie_suffix}`

        fetch(api_url + '/auth/logout', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${tkn}`
            }
        }).then(res => res.json()).then(data => {
            if (debug) console.log('/auth/logout data::', data)
            if (data.status === true) {
                if (window.location.pathname != '/auth/login') {
                    window.location.href = '/auth/login'
                    setTimeout(() => { window.location.reload() }, 1000);
                }
            } else {
                if (debug) console.error('/auth/logout error (doLogout) ::', data)
            }
            if (rtr) {
                if (rtr.pathname != '/auth/login') {
                    rtr.push('/auth/login', undefined, { unstable_skipClientCache: true })
                    setTimeout(() => { rtr.reload() }, 1000);
                }
            } else {
                if (window.location.pathname != '/auth/login') {
                    window.location.href = '/auth/login'
                    setTimeout(() => { window.location.reload() }, 1000);
                }
            }
            // return data
        }).catch(err => {
            if (debug) console.error('/auth/logout error (doLogout) ::', err)
            if (rtr) {
                if (rtr.pathname != '/auth/login') {
                    rtr.push('/auth/login', undefined, { unstable_skipClientCache: true })
                    setTimeout(() => { rtr.reload() }, 1000);
                }
            } else {
                if (window.location.pathname != '/auth/login') {
                    window.location.href = '/auth/login'
                    setTimeout(() => { window.location.reload() }, 1000);
                }
            }
            // return err
        })
    }
}


export const loadConfig = (json, session) => {
    const user = session?.user || null;
    let dataDictionary = {};
    if (json && json.dataDictionary) {
        dataDictionary = json.dataDictionary;
        if (debug) console.log('dataDictionary', dataDictionary);
    } else {
        if (debug) console.log("No dataDictionary found in config");
    }
    if (debug) console.log("Loading config");
    if (debug) console.log("Dictionary: " + Object.keys(dataDictionary).length);
    // if(debug) console.log("Loading config", Object.keys(json), ", Dictionary: ", Object.keys(dataDictionary));
    if (json && Object.keys(json).length > 0 && dataDictionary && Object.keys(dataDictionary).length > 0) {
        let json_str = JSON.stringify(json);
        let regexp = /@ref\(([^)]+)\)/gmi
        let matches = json_str.match(regexp);
        // replace the occurences of @ref(dict: with the value of the key in the object
        if (matches && matches.length > 0) {
            for (let i = 0; i < matches.length; i++) {
                let key = matches[i].replace(regexp, '$1');
                // remove quotes and spaces
                key = key.replace(/['"]+/g, '').replace(/\s+/g, '');
                // for keys with a prefix of dict:, replace with the value of the key in the dictionary
                if (key.startsWith("dict:")) {
                    let value = (dataDictionary[key.replace("dict:", "")]);
                    if (value) {
                        // if(debug) console.log("Value for " + key + ": " + JSON.stringify(value));
                        if (typeof value == "object") {
                            json_str = json_str.replace('"' + matches[i] + '"', JSON.stringify(value));
                        } else {
                            json_str = json_str.replace('"' + matches[i] + '"', value);
                        }
                    } else {
                        if (debug) console.log("No value found for dict:key: ", key);
                        json_str = json_str.replace(matches[i], null);
                    }
                }
                // for keys with a prefix of user:, replace with the value of the key in the user object
                if (key.startsWith("user:")) {
                    json_str = json_str.replace(matches[i], null);
                    json_str = json_str.replace('"' + matches[i] + '"', JSON.stringify(user));
                }
                // TODO: for keys without a prefix (probably form fields), replace with the value of the key in the form object from the global zustand state
                if (!key.startsWith("dict:") && !key.startsWith("user:")) {
                    // check for value in context / state
                    let value = null; //window.zustand.getState()[key];
                    if (debug) console.log("Match: " + matches[i] + " Key: " + key, " Value: ", value);
                    json_str = json_str.replace(matches[i], null); // TODO: replace with value from zustand state
                }
            }
        }
        return JSON.parse(json_str);
    } else {
        if (!json || json.length == 0) {
            if (debug) console.log("No config json found");
        }
        if (!dataDictionary || Object.keys(dataDictionary).length == 0) {
            if (debug) console.log("No data dictionary found");
        }
        return [];
    }
}

// helper functions to get and set cookies
export const getCookie = (name) => {
    if (!name) return null;
    let value = "; " + document.cookie;
    if (debug) console.log("Getting cookie: ", name);
    let parts = value.split("; " + name + "=");
    if (parts.length == 2) {
        let val = parts.pop().split(";").shift();
        if (debug) console.log("Cookie value: ", name, val);
        return val;
    } else {
        return null;
    }
};

export const setCookie = (name, value, days = 3) => {
    if (!name) return;
    // expires is in 1 day
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    if (debug) console.log("Setting cookie: ", name, value, expires);
    document.cookie = name + "=" + (value || "") + expires + "; path=/;" + `${cookie_suffix}`
};

// get user
export const doGetSession = async (skipCache_) => {
    let skipCache = skipCache_ || false
    if (Math.random() < skipcacheratio) skipCache = true;
    if (debug) console.log("doGetSession");
    if (typeof window !== 'undefined') {
        // TODO: first check if the user is logged in i.e. check the session storage / cookie - DONE
        let isLoggedIn = getCookie('isLoggedIn') == 'true' ? true : false;
        if (!isLoggedIn || isLoggedIn == 'false') {
            if (debug) console.log("User is not logged in");
            return null;
        }
        const tkn = getCookie('token');
        if (!tkn) return null;
        const cookie_session = getCookie('session');
        if (cookie_session && !skipCache) {
            // if (debug) console.log("Found session in cookie: ", JSON.parse(cookie_session));
            return JSON.parse(cookie_session);
        }
        return fetch(api_url + '/auth/user', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tkn
            }
        }).then(res => res.json()).then(data => {
            // if (data) {
            if (debug) console.log('/auth/user data (doGetSession) ::', data)
            const apc = getCookie('activeScopeCode') || null;
            if (data.status === true) {
                // return user info
                let session = {
                    // user: { ...data.user, type: (data.user.role == 1 ? "admin" : "participant") },
                    user: {
                        ...data.user,
                        type: data.role?.name,
                        permissions: Array.from(data?.permissions, p => p?.name),
                        scopes: Array.from(data?.scopes, p => {
                            return { uuid: p?.uuid, name: p?.name }
                        }),
                        orgunits: Array.from(data?.orgunits, p => {
                            return { uuid: p?.uuid, name: (p?.meta?.mfl_code ? (p?.meta?.mfl_code + ' ') : '') + p?.name }
                        }),
                    },
                    isLoggedIn: true,
                    token: tkn,
                    activeScopeCode: apc || null,
                }
                if (typeof window !== 'undefined') {
                    // set session in cookie
                    document.cookie = `session=${JSON.stringify(session)}; path=/;${cookie_suffix}`
                }
                return session
            } else {
                // return null
                return null
            }
            // }
        }).catch(error => {
            if (debug) console.error('/auth/user error (doGetSession) ::', error)
        })
    } else {
        if (debug) console.log("User is not logged in: window is undefined");
    }
    return null;
}

export const getActiveSession = (sessionID, recache = false) => {
    if (debug) console.log("getActiveSession", sessionID)
    if (sessionID) {
        const tkn = getCookie('token') || '';
        return fetch(`${api_url}/scope/${sessionID}?details=1`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tkn
            }
        })
            .then((res) => res.json())
            .then((data) => {
                if (data?.data?.uuid) {
                    if (typeof window !== 'undefined') {
                        // set active scope code cookie
                        document.cookie = `activeScopeCode=${data?.data?.uuid}; path=/;${cookie_suffix}`
                        // window.sessionStorage.setItem('activeScopeCode', data?.data?.uuid)
                        // update the activeScopeCode in the session as well
                        if (recache) {
                            let session = getCookie('session')
                            if (session) {
                                let session_data = JSON.parse(session)
                                session_data.activeScopeCode = data?.data?.uuid
                                setCookie('session', JSON.stringify(session_data), 3)
                            }
                        }
                    }
                    return data?.data?.uuid
                }
            })
    } else {
        if (debug) console.log("getActiveSession(): No sessionID found")
        return null;
    }
}

export const getScopeConfig = (id) => {
    if (debug) console.log("getScopeConfig", id)
    const tkn = getCookie('token') || '';
    return fetch(`${api_url}/scope/${id}?details=1`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + tkn
        }
    })
        .then((res) => res.json())
        .then((data) => {
            return data
        })
}


export const getScopes = () => {
    const tkn = getCookie('token') || '';
    return fetch(`${api_url}/scopes?paging=false`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + tkn
        }
    })
        .then((res) => res.json()).then((data) => {
            if (data?.status == true) {
                return data?.data || []
            } else {
                return []
            }
        })
}

export const getResource = (resource, options) => {
    const tkn = getCookie('token') || '';
    // check if resource is a url
    let url
    if (resource.startsWith("http://") || resource.startsWith("https://")) {
        url = resource
    } else {
        url = api_url + '/' + resource
    }
    let request_options = {};
    request_options.method = options?.method || 'GET';
    request_options.headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + tkn,
        ...options?.headers || {}
    };
    if (options?.body) request_options.body = JSON.stringify(options?.body);
    return fetch(url, request_options)
        .then((res) => res.json())
}

export const getResourceRaw = (resource, options) => {
    const tkn = getCookie('token') || '';
    // check if resource is a url
    let url
    if (resource.startsWith("http://") || resource.startsWith("https://")) {
        url = resource
    } else {
        url = api_url + '/' + resource
    }
    let request_options = {};
    request_options.method = options?.method || 'GET';
    request_options.headers = {
        'Authorization': 'Bearer ' + tkn,
        ...options?.headers || {}
    };
    if (options?.body) request_options.body = options?.body;
    return fetch(url, request_options)
        .then((res) => res.json())
}

export const renderElements = (elements, editSection, dataInjector, data) => {
    let elms = []
    if (dataInjector) {
        elements.map((elm, index) => {
            // if elm has text and no children, inject data. this returns an array of elements
            if (elm?.text || elm?.children) {
                const injected = dataInjector(elm, data);
                if (injected.length > 0) {
                    if (injected.length === 1) {
                        elms.push(injected[0])
                    } else {
                        injected.map((injectedElm, index) => {
                            elms.push(injectedElm)
                        })
                    }
                }
            } else {
                elms.push(elm)
            }
        })
    } else {
        elms = elements
    }

    return elms.map((element, index) => {
        const { type, classes, styles, children, ...props } = element;

        if (index === 0 && (type === "div" || type === "section") && editSection && editSection !== undefined && editSection !== null) {
            props.onClick = () => {
                editSection(element?.uuid)
            }
        }

        return React.createElement(
            type,
            {
                className: classes && classes.length > 0 ? (
                    typeof classes === "string" ? classes : (typeof classes === "object" && Array.isArray(classes) ? classes.join(" ") : "")
                ) : "",
                style: styles ? (typeof styles === "object" ? styles : {}) : {},
                key: index,
                // contentEditable: true,
                // suppressContentEditableWarning: true,
                ...props,
            },

            element?.text ? (
                element.text
            ) : element?.children ? renderElements(children, editSection, dataInjector, data) : null
        );
    });
}

export const slugify = (text) => {
    if (!text) return '';
    return text.toString().toLowerCase()
        // Replace spaces and newlines with -
        .replace(/\s+/g, '-')
        // Remove all non-word chars
        .replace(/[^\w\-]+/g, '')
        // Replace multiple - with single -
        .replace(/\-\-+/g, '-')
        // Trim - from start of text
        .replace(/^-+/, '')
        // Trim - from end of text
        .replace(/-+$/, '');
}



export const replaceVariables = (element, data) => {
    let elms = []
    ///// <data
    data = data ? data : {}
    let round = data?.round || {}
    let participant = data?.participant || {}
    let enrollment = data?.enrollment || {}
    let test_methods = data?.test_methods
    let samples = data?.samples || {}
    let submission = data?.submission || {}
    let submission_results = data?.submission_results
    let evaluation = data?.evaluation || {}
    ///// data>

    let dta = { round, participant, enrollment, test_methods, samples, submission, submission_results, evaluation }

    // check if element has an attribute 'data' and the value contains a variable {{variable}} with '@loo

    // check if the element has an attribute 'text'. If yes, check if the text has a variable {{variable}}.
    // If yes, replace the variable with the value from the data object
    // If the variable looks like {{@loop(variable)}}, then loop through the array of objects and replace the variable with the value from the data object
    // If no, return the text as is

    if (element?.data && element.data.includes('@loop')) {
        let data = element.data
        let variables = data.match(/{{(.*?)}}/g)
        if (variables) {
            variables.forEach((variable, vx) => {
                let vars = variable.replace('{{@loop(', '').replace(')}}', '')
                let var_array = dta[vars]
                if (var_array) {
                    var_array.forEach((var_obj, vox) => {
                        if (element?.text) { // repeat the element for each object in the array
                            let var_key_strs = element.text.match(/{{(.*?)}}/g)
                            if (var_key_strs) {
                                let new_text = element.text
                                var_key_strs.forEach((var_key_str, vksx) => {
                                    let var_key = var_key_str.replace('{{', '').replace('}}', '')
                                    new_text = new_text.replaceAll(var_key_str, var_obj[var_key] || '-')
                                })
                                elms.push({ ...element, text: new_text })
                            }
                        } else if (element?.children) { // repeat the children[0] for each object in the array
                            let new_elm = { ...element }
                            let elm_index = elms.findIndex(elm => elm.id === element.id)
                            let new_children = []
                            function processChildNode(node) {
                                if (node?.text) {
                                    let var_key_strs = node.text.match(/{{(.*?)}}/g)
                                    if (var_key_strs) {
                                        let new_text = node.text
                                        var_key_strs.forEach((var_key_str, vksx) => {
                                            let var_key = var_key_str.replace('{{', '').replace('}}', '')
                                            new_text = new_text.replaceAll(var_key_str, var_obj[var_key] || '-')
                                        })
                                        // return { ...node, text: new_text}
                                        new_children.push({ ...node, text: new_text })
                                    }
                                }
                            }
                            if (element.children.length > 0) {
                                element.children.forEach((child, cx) => {
                                    if (child?.text) {
                                        processChildNode(child)
                                    } else if (child?.children) {
                                        child.children.forEach((child2, cx2) => {
                                            if (child2?.text) {
                                                processChildNode(child2)
                                            }
                                        })
                                    }
                                })
                            }
                            new_elm.children = new_children
                            elms.push(new_elm)
                        }
                    })
                }

            })
        }
    } else {
        if (element?.text) {
            let text = element.text
            let variables = text.match(/{{(.*?)}}/g)
            if (variables) {
                let new_element = { ...element }
                let new_text = text
                variables.forEach((variable, vx) => {
                    variable = variable.replaceAll(' ', '')
                    let val = eval(variable) || ''
                    new_text = new_text.replace(variable, val || '')
                    new_element.text = new_text
                })
                elms.push(new_element)
            } else {
                element.text = text
                elms.push(element)
            }
        } else {
            elms.push(element)
        }
    }

    return elms
}
